import { ICcbVinculoAtivo, IVinculoAtivoEmpregadorRetorno } from "@/models/consignado/proposal-billings.model";

// Linha REAL de GET /cobrancas/empregador/:cnpj/vinculos-ativos → shape que
// CcbRow/CcbDetalhe consomem. `id` da rota é o cobranca_clt.id, que o nível 3
// usa como cobranca_id. Vínculos Encerrados reaproveita e soma a badge.
export const hidratarCcbAtivo = (row: IVinculoAtivoEmpregadorRetorno): ICcbVinculoAtivo => ({
  id: row.id,
  cobranca_id: row.id,
  numero_ccb: row.numero_ccb,
  proposta_shorthash: row.proposta_shorthash,
  tomador_nome: row.tomador_nome,
  tomador_documento: row.tomador_documento,
  data_contratacao: row.data_contratacao ?? "",
  qtd_competencias: row.qtd_competencias,
  qtd_nao_escriturados: row.qtd_nao_escriturados,
  qtd_nao_repassado: row.qtd_nao_repassado,
  competencias_resumo: row.competencias_resumo,
  competencia_atraso_mais_antiga: row.competencia_atraso_mais_antiga ?? null,
  tem_negociacao: row.tem_negociacao ?? undefined,
  termino_vinculo: row.termino_vinculo ?? undefined,
  motivo_desligamento: row.motivo_desligamento ?? undefined,
});
